<template>
  <div>
    <ContentWrapperControl class="mt-4">
      <div
        class="bg-white shadow rounded-lg p-6 text-sm leading-normal text-justify"
      >
        <div class="pb-4">
          For the safety and security of all participants, please adhere to the
          instructions and reminders provided by event officials, including
          staff and volunteers. In relation, the following items are strictly
          prohibited:
          <ul class="list-disc pl-6 mt-2">
            <li>Drugs</li>
            <li>Alcoholic Beverages</li>
            <li>
              Weapons, any sharp items, or potentially dangerous items such as
              hammers and knives
            </li>
            <li>Firearms</li>
            <li>
              Unmanned aerial devices, drones, survey balloons, photography
              mini-copters, and any flying device with an on/off switch
            </li>
          </ul>
        </div>
        <div class="pb-4">
          Please abide by the following guidelines and reminders:
          <ul class="list-disc pl-6 mt-2">
            <li>
              Please refrain from engaging with solicitors or vendors of
              unofficial merchandise.
            </li>
            <li>
              Parents and guardians are responsible for ensuring the safety of
              their children at all times.
            </li>
            <li>Please respect our no-smoking policy throughout the event.</li>
            <li>Always adhere to directional signage and guidelines.</li>
            <li>Please do not enter unauthorized areas.</li>
            <li>
              There will be no baggage deposit counters at the event. You are
              responsible for the safekeeping of your own personal belongings.
              PAFCPIC will not be held liable for any loss or damage to personal
              property or items.
            </li>
            <li>
              Parking spaces are limited and available on a first-come,
              first-served basis. Monitor our Facebook page as we post the
              available parking sites inside and within the vicinity of the
              Philippine Army Grandstand.
            </li>
            <li>
              Please use the marked entrances and exits for both pedestrians and
              vehicles. Use Gate 4 for the ENTRANCE and Gate 3 for the EXIT.
              Both gates are located along Lawton Avenue across the Land Bank
              branch.
            </li>
          </ul>
        </div>
        <div class="flex flex-row items-center mt-4">
          <ButtonControl
            @click="this.$router.push('/fun-run/summary')"
          >
            {{ lang("lbl_0000033") }}
          </ButtonControl>
        </div>
      </div>
    </ContentWrapperControl>
  </div>
</template>

<script>
import ContentWrapperControl from "./../../components/controls/ContentWrapperControl.vue";
import ButtonControl from "./../../components/controls/ButtonControl.vue";
import mixin from "./../../mixin.js";

export default {
  mixins: [mixin],
  components: {
    ContentWrapperControl,
    ButtonControl,
  },
  mounted() {
    this.$emit("shownavbar", {
      title: this.lang("lbl_0000323"),
      show: true,
      back: true,
    });
    this.$emit("nofooter", false);
  },
};
</script>
